module.exports = __webpack_public_path__ + "static/media/img_patient_accept.a4b5c730.svg";